export const products = {
  'Amplr Track Competitor': {
    EUR: {
      monthly: {
        price: '9€',
        id: 'prod_T8jXKNgNWSaj5h',
        priceId: 'price_1SCS4GBZn8ZsgWEijQTQu5l7'
      },
      annual: {
        price: '90€',
        id: 'prod_T8jXKNgNWSaj5h',
        priceId: 'price_1SCS4dBZn8ZsgWEiPURU9inY'
      }
    },
    mode: 'subscription' as const,
    description: 'Suivi avancé de vos concurrents Instagram',
    features: [
      'Suivi en temps réel des concurrents',
      'Évolution des abonnés (gains/pertes)',
      'Détection des changements de bio',
      'Alertes nouveaux posts',
      'Historique complet des données',
      'Rapports détaillés'
    ],
    included: [true, true, true, true, true, true],
  },
  'Amplr Start': {
    EUR: {
      monthly: {
        price: '74€',
        id: 'prod_S896Pa8cRqmvDF',
        priceId: 'price_1RDsoEBZn8ZsgWEiCOBvt7U8'
      },
      annual: {
        price: '532€',
        id: 'prod_SB5SUe0apELr1c',
        priceId: 'price_1RGjHkBZn8ZsgWEiPJV9hDV2'
      }
    },
    USD: {
      monthly: {
        price: '$74',
        id: 'prod_SB5MxANyMoYzRz',
        priceId: 'price_1RGjBQBZn8ZsgWEi7xId61ph'
      },
      annual: {
        price: '$532',
        id: 'prod_SB5VbCMaExMGlb',
        priceId: 'price_1RGjKaBZn8ZsgWEiL8AUkcll'
      }
    },
    mode: 'subscription' as const,
    description: 'L\'essentiel pour démarrer votre croissance Instagram',
    features: [
      'Résultats en 24 heures',
      'Croissance garantie ou remboursée',
      'Jusqu\'à 250 abonnés réels et qualifiés / mois',
      'Interactions automatisées',
      'Statistiques détaillées',
      'Support par email (sous 72 heures)'
    ],
    included: [true, true, true, true, true, true],
  },
  'Amplr Max': {
    EUR: {
      monthly: {
        price: '94€',
        id: 'prod_S89556wcwPMNLm',
        priceId: 'price_1RDsnXBZn8ZsgWEifee21lLs'
      },
      annual: {
        price: '676€',
        id: 'prod_SB5Tfy5Qqpoaqh',
        priceId: 'price_1RGjINBZn8ZsgWEiSBaeb8dD'
      }
    },
    USD: {
      monthly: {
        price: '$94',
        id: 'prod_SB5Mbxdpnrrzue',
        priceId: 'price_1RGjBvBZn8ZsgWEiEVOL2w5Z'
      },
      annual: {
        price: '$676',
        id: 'prod_SB5bsqajIo4pgu',
        priceId: 'price_1RGjQfBZn8ZsgWEi4gZVj410'
      }
    },
    mode: 'subscription' as const,
    description: 'L\'offre préférée de 80% de nos clients',
    features: [
      'Résultats en 24 heures',
      'Croissance garantie ou remboursée',
      'Jusqu\'à 450 abonnés réels et qualifiés / mois',
      'Interactions automatisées [+ Amplr AI Boost]',
      'Welcome DM automatique',
      'Ajout en amis proches (jusqu\'à 7 500 abonnés)',
      'Statistiques avancées',
      'Support prioritaire (sous 48 heures)'
    ],
    included: [true, true, true, true, true, true, true, true],
    popular: true,
  },
  'Amplr Pro': {
    EUR: {
      monthly: {
        price: '294€',
        id: 'prod_S896R0WlF5XqL7',
        priceId: 'price_1RDsoTBZn8ZsgWEisQR0Cw0h'
      },
      annual: {
        price: '2116€',
        id: 'prod_SB5TX8D9rKncxv',
        priceId: 'price_1RGjIrBZn8ZsgWEiylpKw6m7'
      }
    },
    USD: {
      monthly: {
        price: '$294',
        id: 'prod_SB5N6dbCdo0X4d',
        priceId: 'price_1RGjCSBZn8ZsgWEiwyCZ0XMX'
      },
      annual: {
        price: '$2116',
        id: 'prod_SB5cV7te87bmvq',
        priceId: 'price_1RGjR1BZn8ZsgWEieqbqkbgm'
      }
    },
    mode: 'subscription' as const,
    description: 'Pour les professionnels qui visent l\'excellence',
    features: [
      'Résultats en 24 heures',
      'Croissance garantie ou remboursée',
      'Jusqu\'à 800 abonnés réels et qualifiés / mois',
      'Interactions automatisées [+ Amplr AI Boost]',
      'Welcome DM automatique',
      'Ajout en amis proches (jusqu\'à 7 500 abonnés)',
      'Audit vidéo expert (plan d\'action personnalisé)',
      '1 appel stratégique / mois',
      'Statistiques premium',
      'Support premium (sous 24 heures, canal privé Slack)'
    ],
    included: [true, true, true, true, true, true, true, true, true, true],
  }
} as const;